import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type OfferFragment = { id: string, name: string, description: string, sortOrder: number, url: string };

export const OfferFragmentDoc = gql`
    fragment OfferFragment on OfferType {
  id
  name
  description
  sortOrder
  url
}
    `;